import store from './store'
export const functions = {
    test(){
        // store.dispatch('isCompatible', {item: item, withType: withType, option: option})
    },
    createCompatTable       ({build, checkItem}){
        // var startTime = performance.now()
        var testCases = {
            cpu: {
                motherboard: [
                    'socket',
                    'generation'
                ],
                ram: [
                    'ram_type',
                    'ram_speed',
                    'max_memory',
                ],
                cooling: [
                    'socket',
                ]
            },
            motherboard: {
                cpu: [
                    'socket',
                    'ram_type',
                    'ram_speed',
                    'processor_generation',
                ],
                ram: [
                    'ram_type',
                    'ram_speed',
                    'number_of_items',
                    'max_memory'
                ],
                psu: [
                    'form_factor'
                ],
                case: [
                    'form_factor'
                ],
            },
            ram: {
                cpu: [
                    'ram_type',
                    'ram_speed',
                    'max_memory'
                ],
                motherboard: [
                    'ram_type',
                    'max_memory',
                    'ram_speed',
                    'ram_slots'
                ]
            },
            storage: {
                motherboard: [
                    'interface',
                    'sata',
                    'sata_slots',
                    'm.2_slots'
                ],
            },
            graphics: {
                motherboard: [
                    'pci_e_x16'
                ],
            },
            psu: {
                general: [
                    'power'
                ],
                motherboard: [
                    'form_factor'
                ],
                case: [
                    'form_factor'
                ],
            },
            case: {
                motherboard: [
                    'form_factor'
                ],
                psu: [
                    'form_factor'
                ],
                cooling: [
                    'form_factor',
                ]
            }
        }
        var buildList = Object.keys(build)
        var oneItem
        var otherItem
        var oneItemType
        var otherItemType
        var option = ''
        // var compatTable = {}
        // If Item exists in build
        store.dispatch('resetWarnings')
        if(checkItem){
            buildList.forEach(type => {
                if(build[type] && build[type].item.contents){
                    otherItem = build[type]
                    otherItemType = otherItem.type
                    for (var i = 0; i< buildList.filter((item) => item !== otherItemType).length; i++){
                        oneItem = {
                            type: checkItem.type,
                            item: {
                                contents: checkItem
                            }
                        }
                        // IF NOT ARRAY
                        if(oneItem.item.contents && oneItem.item.contents.type){
                            oneItemType = oneItem.type
                            if(oneItem.type == 'gpu'){
                                oneItemType = 'graphics'
                             }
                            if(    testCases[oneItemType] 
                                && testCases[oneItemType][otherItemType] 
                                && testCases[oneItemType][otherItemType].length >0){
                                for(var opt = 0; opt < testCases[oneItemType][otherItemType].length; opt++){
                                    option  = testCases[oneItemType][otherItemType][opt]
                                    store.dispatch('isCompatible', {item: oneItem.item.contents, withType: otherItemType, option: option, forLib: true})
                                }
                            }
                        }
                        // IF ARRAY
                        if(oneItem.item.contents && typeof(oneItem.item.contents) == 'object' && oneItem.item.contents.length >0){
                            oneItemType = oneItem.item.contents[0].type
                            if(oneItem.type == 'gpu'){
                               oneItemType = 'graphics'
                            }
                            for(var m = 0; m < oneItem.item.contents.length; m++){
                                if(    testCases[oneItemType] 
                                    && testCases[oneItemType][otherItemType] 
                                    && testCases[oneItemType][otherItemType]){
                                    for(var opti = 0; opt < testCases[oneItemType][otherItemType].length; opti++){
                                        option  = testCases[oneItemType][otherItemType][opti]
                                        store.dispatch('isCompatible', {item: oneItem.item.contents[m], withType: otherItemType, option: option, forLib: true})
                                    }
                                }
                            }
                        }
                    }
                }
            });
            // var endTime = performance.now()
            return store.getters.getCompatLib
        }
        else if(build){
            buildList.forEach(type => {
                if(build[type] && build[type].item.contents){
                    otherItem = build[type]
                    otherItemType = otherItem.type
                    for (var i = 0; i< buildList.filter((item) => item !== otherItemType).length; i++){
                        oneItem = build[buildList[i]]
                        // IF NOT ARRAY
                        if(oneItem.item.contents && oneItem.item.contents.type){
                            oneItemType = oneItem.type
                            if(    testCases[oneItemType] 
                                && testCases[oneItemType][otherItemType] 
                                && testCases[oneItemType][otherItemType].length >0){
                                for(var opt = 0; opt < testCases[oneItemType][otherItemType].length; opt++){
                                    option  = testCases[oneItemType][otherItemType][opt]
                                    store.dispatch('isCompatible', {item: oneItem.item.contents, withType: otherItemType, option: option, forState: true})
                                }
                            }
                        }
                        // IF ARRAY
                        if(oneItem.item.contents && typeof(oneItem.item.contents) == 'object' && oneItem.item.contents.length >0){
                            oneItemType = oneItem.item.contents[0].type
                            if(oneItem.type == 'gpu'){
                               oneItemType = 'graphics'
                           }
                            for(var m = 0; m < oneItem.item.contents.length; m++){
                                if(    testCases[oneItemType] 
                                    && testCases[oneItemType][otherItemType] 
                                    && testCases[oneItemType][otherItemType]){
                                    for(var opty = 0; opty < testCases[oneItemType][otherItemType].length; opty++){
                                        option  = testCases[oneItemType][otherItemType][opty]
                                        store.dispatch('isCompatible', {item: oneItem.item.contents[m], withType: otherItemType, option: option, forState: true})
                                    }
                                }
                            }
                        }
                    }
                }
            });
            console.log('compatibility table updated ', store.getters.getStateCompatTable)
            if(store.getters.getWarnings && store.getters.getWarnings.length > 0){
                store.dispatch('updateBuildStatus', 'warning')
            }
            else {
                store.dispatch('updateBuildStatus', 'ok')
            }
            // var endTime = performance.now()
            // console.log('[createCompatTable] EXECUTED IN ', (endTime - startTime)/1000 + ' seconds')
            return store.getters.getStateCompatTable
        }
    },
    getBuildPerformance(build, myBuild){
        var results = {}
        if(build) {
            var totalItems = 0;
            var totalScore = 0;
            for (const field in build){
                var type = ''
                var processingItem = new Object()
                var perfIndex = 0
                // IF RANDON BUILD
                if(myBuild == false){
                    if(build[field] && typeof(build[field]) == 'object' && build[field][0]){
                        if(build[field][0]){
                            type = build[field][0].type
                            processingItem = build[field]
                        }
                    }
                    else {
                        if(build[field] && build[field].type){
                            type = build[field].type
                            processingItem = build[field]
                        }
                    }
                }
                else {
                    if(build[field] && build[field].item && build[field].item.type){
                        type = build[field].item.type
                        processingItem = build[field].item.contents
                    }
                }
                if(processingItem){
                    if(!results[type]) {
                        results[type] = 0
                    }
                    // IF GPU RAM STORAGE
                    if(typeof(processingItem) == 'object' && processingItem.length >0){
                        perfIndex = 0;
                        var pciStorage = 0
                        var sataHddStorage = 0
                        var sataSsdStorage = 0
                        var storagePerf = 0
                        var graphics = 0
                        for (var i = 0; i< processingItem.length; i++){
                            if(type == 'ram'){
                                var ramPerf = (parseFloat(processingItem[i].compat.capacity)*0.5)
                                totalScore += ramPerf
                                results[type] = results[type] + ramPerf
                            }
                            if(type == 'graphics' || type == 'gpu'){
                                graphics++
                                perfIndex = 0;
                                var core_freqency           = parseFloat(processingItem[i].specs [ 'GPU_clock_speed'     ]);
                                // var mem_clock               = parseInt(processingItem[i].specs   [ 'memory_clock_speed'  ]);
                                // var memory_bus_width        = parseFloat(processingItem[i].specs [ 'memory_bus_width'    ]);
                                // var graphics_ram_type       = parseFloat(processingItem[i].specs[  'graphics_ram_type'   ]);
                                var graphics_ram_capacity   = parseFloat(processingItem[i].specs[  'graphics_ram_capacity'   ]);
                                var memory_transfer_speed   = parseFloat(processingItem[i].specs[  'memory_transfer_speed'   ]);
                                var gpuPerformance = parseFloat(processingItem[i].specs [ 'GPU_clock_speed'     ]);
                                var memPerformance = parseInt(processingItem[i].specs   [ 'memory_clock_speed'  ]) * parseFloat(processingItem[i].specs [ 'memory_bus_width'    ]);
                                var transferSpeed = 0
                                perfIndex = (
                                    (memory_transfer_speed*0.1)*(core_freqency*graphics_ram_capacity/1000)
                                ) * 0.21
                                processingItem[i]['performance'] =  perfIndex
                                if(graphics == 2){
                                    var gpuPerf = parseFloat(processingItem[i].performance)/2
                                    totalScore += gpuPerf
                                    results[type] = results[type] + gpuPerf
                                }
                                else if(graphics == 1){
                                    var gpuPerf1 = parseFloat(processingItem[i].performance)
                                    totalScore += gpuPerf1
                                    results[type] = results[type] + gpuPerf1
                                }
                            }
                            if(type == 'storage'){
                                if(processingItem[i].compat.compat_interface.toLowerCase().includes('sata')){
                                    var diskType = processingItem[i].specs.Disk_Type
                                    if(diskType && diskType.toLowerCase() == 'hdd'){
                                        sataHddStorage++
                                        if(sataHddStorage >1){
                                            var storagePerf = parseFloat(processingItem[i].specs.Capacity)/3
                                            totalScore += storagePerf
                                            results[type] = results[type] + storagePerf
                                        }
                                        else if(sataHddStorage == 1){
                                            var storagePerf = ((parseFloat(processingItem[i].compat.speed)*0.1)*parseFloat(processingItem[i].specs.Capacity)) *0.1
                                            results[type] = results[type] + storagePerf
                                            totalScore += storagePerf
                                        }
                                    }
                                    if(diskType && diskType.toLowerCase() == 'ssd'){
                                        sataSsdStorage++
                                        if(sataSsdStorage >1){
                                            var storagePerf_temp = parseFloat(processingItem[i].specs.Capacity)*3
                                            results[type] = results[type] + storagePerf_temp
                                            totalScore += storagePerf_temp
                                        }
                                        else if(sataSsdStorage == 1 && pciStorage == 0){
                                            var storagePerf_temp = ((parseFloat(processingItem[i].compat.speed)*0.1)*parseFloat(processingItem[i].specs.Capacity)) *0.7
                                            totalScore += storagePerf_temp
                                            results[type] = results[type] + storagePerf_temp
                                        }
                                    }
                                }
                                if(processingItem[i].compat.compat_interface.toLowerCase().includes('pci')){
                                    pciStorage++
                                    if(pciStorage >1){
                                        var storagePerf_temp = parseFloat(processingItem[i].specs.Capacity)
                                        results[type] = results[type] + storagePerf_temp
                                        totalScore += storagePerf_temp
                                    }
                                    else if(pciStorage == 1){
                                        if(sataSsdStorage > 0){
                                            totalScore -= storagePerf
                                            storagePerf = 0
                                        }                                        
                                        var storagePerf_temp = ((parseFloat(processingItem[i].compat.speed)*0.1)*parseFloat(processingItem[i].specs.Capacity)) *0.05
                                        totalScore += storagePerf_temp
                                        results[type] = results[type] + storagePerf_temp
                                    }
                                }
                                //  totalScore += parseFloat(processingItem[i].compat.speed)*0.01
                            }
                            totalItems = totalItems++
                        }
                    }
                    else {
                        if(type == 'cpu'){
                            perfIndex = 0;
                            var frequency   = parseFloat(processingItem.specs[ 'Core_Frequency'    ]);
                            var TurboFreq   = parseFloat(processingItem.specs[ 'Turbo_Frequency'   ]);
                            var cores       = parseInt(processingItem.specs[   'Number_of_Cores'   ]);
                            var turb        = parseFloat(processingItem.specs[ 'Turbo_Boost'       ]);
                            var hyper       = processingItem.specs[            'Hyper_Threading'   ];
                            if(frequency && frequency > 1000){
                                frequency = frequency/1000
                            }
                            if(turb == true){
                                frequency = TurboFreq
                            }
                            perfIndex = frequency*cores
                            // increase by 30% If Hyper-Threading
                            if(typeof(hyper) == 'string' && hyper !== '' && hyper !== 'No'){
                                perfIndex += perfIndex *0.3
                            }
                            if(typeof(turb) == 'string' && turb !== '' && turb !== 'No'){
                                perfIndex += perfIndex *(1/frequency)
                            }
                            // increase by % if Turbo Boost
                            processingItem['performance'] =  perfIndex
                            var cpuPerf = parseFloat(processingItem.performance)
                            totalScore += cpuPerf
                            results[type] = cpuPerf
                        }
                        totalItems = totalItems++
                    }

                }
            }
            var totScore = myBuild == false ? Math.round(totalScore) : Math.round(totalScore+(totalScore*0.15))
            return {
                'Total': totScore,
                'Details': results
            }
            return totScore
        }
    },
    checkPartCompat({compatTable, type, asin}){
        var table = compatTable
        if(table && type && asin){
          if(table[asin] && table[asin][type.toLowerCase()]){
            var fields = Object.keys(table[asin][type.toLowerCase()])
            if(fields && fields.length >0){
              for(var i = 0; i < fields.length; i++){
                if(table[asin][type.toLowerCase()][fields[i]]){
                  var values = Object.keys(table[asin][type.toLowerCase()][fields[i]])
                  for(var j = 0; j < values.length; j++){
                    if(table[asin][type.toLowerCase()][fields[i]][values[j]]
                    && table[asin][type.toLowerCase()][fields[i]][values[j]].compatible == false){
                      return false
                    }
                  }
                }
              }
            }
          }
        }
    },
    checkCompatTable(type, option, build, item, compatTable){
        var currentItemType = item.type
        if(type == 'general'){
            if(
                   compatTable[currentItemType]
                && compatTable[currentItemType][type]
                && compatTable[currentItemType][type][option]
                && compatTable[currentItemType][type][option].compatible == false
            ){
                return false
            }
            if(
                   compatTable[currentItemType]
                && compatTable[currentItemType][type]
                && compatTable[currentItemType][type][option]
                && compatTable[currentItemType][type][option].compatible == true
            ){
                return true
            }
        }
        if(
            build
            && build[type]
            && build[type].item.contents
            && compatTable[currentItemType]
            && compatTable[currentItemType][type]
            && compatTable[currentItemType][type][option]
            && compatTable[currentItemType][type][option].compatible == false
        ){
            return false
        }
        else if (
            build
            && build[type]
            && build[type].item.contents
            && compatTable[currentItemType]
            && compatTable[currentItemType][type]
            && compatTable[currentItemType][type][option]
            && compatTable[currentItemType][type][option].warning == true
        ){
            return 'warning'
        }
        else if (
            build
            && build[type]
            && build[type].item.contents
            && compatTable[currentItemType]
            && compatTable[currentItemType][type]
            && compatTable[currentItemType][type][option]
            && compatTable[currentItemType][type][option].compatible == true
        ){
            return true
        }
        else return 
    },
    getItemValue({item, field}){
        if(item && item !== null){
            // console.log('getting item value: ', field, ' from ', item)
            var type = ''
            var length = 0
            var capacity = 0
            var ram_type
            if(item && typeof(item) == 'object' && item.length >0){
                type = item[0].type
                length = item.length
            }
            else {
                type = item.type
            }
            // console.log('item type recognized: ', type)

            if(type == 'motherboard'){
                if(field == 'ram_type'){
                    ram_type = item.compat.ram
                    // console.log('returning ram type ', item.compat.ram)
                    return ram_type
                }
            }
            if(type == 'ram'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.compat.capacity))
                    }
                    return capacity
                }
                if(field == 'ram_type'){
                    ram_type = item[0].compat.ram_type
                    // console.log('returning ram type ', item[0].compat.ram_type)
                    return ram_type
                }
                if(field == 'slots'){
                    var slots = 0
                    if(length >0){
                        item.map((itm) => slots += parseInt(itm.compat.number_of_items))
                    }
                    return slots
                }
            }
            if(type == 'storage'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.specs.Capacity))
                    }
                    return capacity
                }
            }
        }
    },  
    cents(num){
        var numbr = parseFloat(num).toFixed(2)
        var remainder = numbr%1
        var cents = (remainder*100).toFixed(0)
        if(cents == 0){
            return '00'
        }
        if(cents < 10){
          return '0'+cents
        }
        return cents
    },
    getItemValueMenu({item, field}){
        console.log('getting item value: ', field, ' from ', item)
        var type = ''
        var length = 0
        var capacity = 0
        if(item && typeof(item) == 'object' && item.length >0){
            type = item[0].type
            length = item.length
        }
        else {
            type = item.type
        }
        if(type == 'ram'){
            if(field == 'capacity'){
                capacity = 0
                if(length >0){
                    item.map((itm) => capacity += parseInt(itm.compat.capacity))
                }
                return capacity
            }
        }
        if(type == 'storage'){
            if(field == 'capacity'){
                capacity = 0
                if(length >0){
                    item.map((itm) => capacity += parseInt(itm.specs.Capacity))
                }
                return capacity
            }
        }
        if(type == 'graphics' || type == 'gpu'){
            if(field == 'model'){
                var model = item.model || ''
                if(length >0){
                    model = item[0].model
                }
                console.log('got model: ', model)
                return model
            }
        }
    },
}